<template>
  <footer class="footer">
    <p class="copyright">
      © {{ new Date().getFullYear() }} DartsHub - Tous droits réservés.
    </p>

    <p class="copyright">
      <a class="footer-link" :href="`${authUrl}/mentions-legales`" target="_blank" rel="noopener noreferrer">
        Mentions légales
      </a>
      |
      <a class="footer-link" :href="`${authUrl}/politique-confidentialite`" target="_blank" rel="noopener noreferrer">
        Politique de confidentialité
      </a>
      |
      <a href="#" class="footer-link" @click.prevent="openCookieBanner">
        Gestion des cookies
      </a>
      |
      <router-link class="footer-link" to="/services">Services</router-link>
      |
      <a class="footer-link" :href="`${authUrl}/contact`" target="_blank" rel="noopener noreferrer">
        Nous contacter
      </a>
      |
      <a class="footer-link" href="https://www.facebook.com/dartshub.fr" target="_blank" rel="noopener noreferrer"
        aria-label="Facebook DartsHub">
        <i class="fa-brands fa-facebook-f"></i>
      </a>
    </p>
  </footer>
</template>

<script setup>
import { auth_url as authUrl } from '@/config/config'

const openCookieBanner = () => {
  window.dispatchEvent(new Event('open-cookie-banner'))
}
</script>

<style scoped>
.footer {
  margin-top: 3rem;
  padding: 1.5rem 1rem;
  text-align: center;
  font-size: 0.85rem;
  border-top: 1px solid var(--color-light-shadow);
}

.footer-link {
  color: var(--color-fg-darker);
  text-decoration: none;
  font-weight: 600;
}

.footer-link:hover {
  color: var(--color-accent);
  text-decoration: underline;
}

.copyright {
  margin: 0.35rem 0 0;
  color: var(--color-fg-darker);
}
</style>
